import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, MUTATION_KEYS, queryClient } from '../queryClient';
import { updateCacheArray, CACHE_ACTIONS } from '../cacheClient';
import { getQueryKey as getQueryKeyCriteriaResources } from './useCriteriaResources';
import { getQueryKey as getQueryKeyCriteriaResourceById } from './useGetCriteriaResourceById';

// Config
import { uiConfig } from '../../../conf/criteriaResources';

export const getMutationKey = getQueryKeyBase.bind(null, MUTATION_KEYS.CRITERIA_RESOURCE);

export const useCreateCriteriaResource = ({ crudConfig, sessionToken, onSuccessCb, onErrorCb, onSettledCb }) => {
    const Client = apiClient(crudConfig);

    return useMutation({
        mutationKey: getMutationKey(),
        mutationFn: ({ newResource }) => Client.insert(sessionToken, newResource),
        onSuccess: (data, variables) => {
            updateCacheArray({
                queryKey: getQueryKeyCriteriaResources(),
                action: CACHE_ACTIONS.INSERT,
                primaryKey: uiConfig.primaryKey,
                data
            });
            queryClient.invalidateQueries({
                queryKey: getQueryKeyCriteriaResourceById(data.resourceId)
            });
            onSuccessCb?.({ data: data.resourceId, context: variables?.context });
        },
        onError: (error) => {
            console.log('Error', error);
            onErrorCb?.(error);
        },
        onSettled: () => {
            onSettledCb?.();
        },
        refetchOnWindowFocus: false
    });
};
